import { Modal } from "antd";
import React from "react";
import "./PopUpConfirm.css";

const PopUpConfirm = ({ isOpen, onClose, onConfirm }) => {

    return (
        <Modal
            className="confirm"
            title="Potwierdzenie"
            open={isOpen}
            onOk={onConfirm}
            onCancel={onClose}
            okText="Usuń konto"
            cancelText="Anuluj"
            centered
            okButtonProps={{
                className: "custom-ok-btn",
            }}
            cancelButtonProps={{
                className: "custom-cancel-btn",
            }}   
        >
            <p>Czy na pewno chcesz usunąć swoje konto?</p>
        </Modal>
    );
};

export default PopUpConfirm;
